export default function componentForRow(
  collectionForIdentifier,
  item,
  selectKit
) {
  return selectKit.modifyComponentForRow(collectionForIdentifier, item);
}
